import React, { Children } from 'react';
import { FormField } from "admin-on-rest";
export const renderItemFormEvent = (children, record, resource, basePath) =>
Children.map(
  children,
  input =>
    input &&
    (input.props.source === "event.date" || input.props.source === "event.term") && (
      <div
        key={input.props.source}
        className={`aor-input-${input.props.source}`}
        style={input.props.style}
      >
        <FormField
          input={input}
          resource={resource}
          record={record}
          basePath={basePath}
        />
      </div>
    )
);


// WEBPACK FOOTER //
// ./src/products/edit/EventField.js